import { render, staticRenderFns } from "./TaskViewStepHeaders.vue?vue&type=template&id=3de16d91&scoped=true"
import script from "./TaskViewStepHeaders.vue?vue&type=script&lang=js"
export * from "./TaskViewStepHeaders.vue?vue&type=script&lang=js"
import style0 from "./TaskViewStepHeaders.vue?vue&type=style&index=0&id=3de16d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de16d91",
  null
  
)

export default component.exports